
export const logUserActivity = async (userEmail: string, actionType: "Login" | "Logout", token: string) => {
    try {
        const response = await fetch(`/api/FxUserActivityLog`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json", "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                UserEmail: userEmail,
                ActionType: actionType,
            }),
        });

        if (!response.ok) {
            console.error("Failed to log user activity:", await response.text());
        } else {
            console.log("User activity logged successfully");
        }
    } catch (error) {
        console.error("Error logging user activity:", error);
    }
};

export const fetchGroupIdsFromRfq = async (
    rfqNumber?: string,
    accessToken?: string,
    accessTokenGraph?: string

): Promise<boolean> => {
    if (!rfqNumber || !accessToken) {
        console.warn("rfqNumber or accessToken is missing");
        return false;
    }

    try {
        const response = await fetch("/api/FxGetGroupIdsFromRfqNumber" as string, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${accessToken}`,
            },
            body: JSON.stringify({ rfqNumber: rfqNumber, graphToken: accessTokenGraph}),
        });

        if (!response.ok) {
            console.error("Failed to fetch group IDs:", await response.text());
            return false;
        }

        const data = await response.json();
        return data?.hasPermission;
       
    } catch (error) {
        console.error("Error fetching group IDs:", error);
        return false;
    }
};




